import React, { useState } from 'react';
import Rating from '../Rating';
import { COMPANY_NAME } from '../../constants/brand';

export default function Testimonial() {
  const [activeTab, setActiveTab] = useState(2);
  const handleTabClick = tabNumber => {
    setActiveTab(tabNumber);
  };
  return (
    <div className="cs_tabs cs_style1">
      <ul className="cs_tab_links">
        <li className={activeTab === 1 ? 'active' : ''}>
          <div className="cs_tab_link_in" onClick={() => handleTabClick(1)}>
            <div className="cs_testimonial_1_avatar">
              <img src="/images/home_1/ali_small.jpg" alt="Avatar" />
              <div className="cs_testimonial_1_avatar_right">
                <h3 className="cs_fs_24 cs_semibold mb-0">Ali Al Hilal</h3>
                <p className="cs_heading_color mb-0">Saudi Arabia</p>
              </div>
            </div>
          </div>
        </li>
        <li className={activeTab === 2 ? 'active' : ''}>
          <div className="cs_tab_link_in" onClick={() => handleTabClick(2)}>
            <div className="cs_testimonial_1_avatar">
              <img src="/images/home_1/adel_small.jpg" alt="Avatar" />
              <div className="cs_testimonial_1_avatar_right">
                <h3 className="cs_fs_24 cs_semibold mb-0">Adel Jaber Al Dosari</h3>
                <p className="cs_heading_color mb-0">Bahrain</p>
              </div>
            </div>
          </div>
        </li>
        <li className={activeTab === 3 ? 'active' : ''}>
          <div className="cs_tab_link_in" onClick={() => handleTabClick(3)}>
            <div className="cs_testimonial_1_avatar">
              <img src="/images/home_1/ishaq_small.jpg" alt="Avatar" />
              <div className="cs_testimonial_1_avatar_right">
                <h3 className="cs_fs_24 cs_semibold mb-0">Ishaq Khalid Muhammed</h3>
                <p className="cs_heading_color mb-0">Oman</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div className="cs_tab_body">
        {activeTab === 1 && (
          <div className="cs_testimonial cs_style_1">
            <img src="/images/icons/quote.svg" alt="Icon" />
            <p>
            {COMPANY_NAME} made my medical journey seamless and stress-free. From visa assistance to top-quality healthcare, everything was handled with professionalism and care. The doctors were highly skilled, and the post-treatment support was excellent. I highly recommend {COMPANY_NAME} for anyone seeking medical treatment in Kerala.
            </p>
            <p>Ali Al Hilal<br></br>Saudi Arabia</p>
            <Rating ratingNumber={5} />
          </div>
        )}
        {activeTab === 2 && (
          <div className="cs_testimonial cs_style_1">
            <img src="/images/icons/quote.svg" alt="Icon" />
            <p>
            I had an excellent experience with {COMPANY_NAME}. Their team handled everything smoothly, from my medical consultation to travel and accommodation. The doctors were highly professional, and the treatment exceeded my expectations. I truly appreciate their support and highly recommend their services.
            </p>
            <p>Adel Jaber Al Dosari<br></br>Bahrain</p>
            <Rating ratingNumber={4.5} />
          </div>
        )}
        {activeTab === 3 && (
          <div className="cs_testimonial cs_style_1">
            <img src="/images/icons/quote.svg" alt="Icon" />
            <p>
            {COMPANY_NAME} provided exceptional service throughout my medical journey. Their seamless coordination of treatment, travel, and accommodation made everything stress-free. The doctors were highly skilled, and the post-treatment care was outstanding. I highly recommend {COMPANY_NAME} to anyone seeking quality healthcare in Kerala.
            </p>
            <p>Ishaq Khalid Muhammed<br></br>Oman</p>
            <Rating ratingNumber={4.5} />
          </div>
        )}
      </div>
    </div>
  );
}
